var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.fields)?_c('div',{staticClass:"tableau-embed-wrapper"},[_c('div',{staticStyle:{"position":"relative"},attrs:{"id":_vm.data.fields.tableauID}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }